import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IfAllowedDirective } from '@k2/common/permissions/if-allowed.directive';
import { IsAllowedPipe } from '@k2/common/permissions/is-allowed.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [IsAllowedPipe, IfAllowedDirective],
  exports: [IsAllowedPipe, IfAllowedDirective]
})
export class PermissionsModule {}
